export const allowedTypes = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "video/mp4",
  "video/x-msvideo",
  "audio/mpeg",
  "audio/wav",
];

